import { REHYDRATE } from 'redux-persist/constants';

export default function reducer(state = {}, action = {}) {
  if (action.type === REHYDRATE) {
    return {
      ...state,
      loaded: true,
    };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/redux/modules/rehydrate.js